<style scoped>
</style>

<template>
  <v-container fluid>
    <v-stepper v-model="e1" @change="se_step()">
      <v-stepper-header>
        <v-stepper-step :complete="isComplete1" step="1"
          >ใบเสนอราคา
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="isComplete2" step="2"
          >ใบวางบิล / แจ้งหนี้</v-stepper-step
        >

        <v-divider></v-divider>

        <v-stepper-step :complete="isComplete3" step="3">สัญญา</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="isComplete4" step="4"
          >ใบกำกับภาษี</v-stepper-step
        >

        <!-- <v-stepper-step step="4" :editable="editable">ใบเสร็จ</v-stepper-step> -->
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <QuotationForm ref="quotaion_from" />
        </v-stepper-content>

        <v-stepper-content step="2">
          <BillForm ref="bill_form" />
        </v-stepper-content>

        <v-stepper-content step="3">
          <ContractForm ref="contract_from" />
        </v-stepper-content>

        <v-stepper-content step="4">
          
          <InvoiceForm ref="invoice_form" />
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-container>
</template>

<script>
import BillForm from "./forms/BillForm";
import QuotationForm from "./forms/QuotationForm";
import ContractForm from "./forms/ContractForm";
import InvoiceForm from "./forms/InvoiceForm";
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  name: "AllForm",
  components: {
    BillForm,
    QuotationForm,
    ContractForm,
    InvoiceForm
  },
  props: {
    page: String
  },
  computed: {
    ...mapGetters({
      CU_GET_ALL: 'CustomerDetail/GET_CUSTOMER',
      Q_GET: "Quotation/GET_QUOTATION",
      GET_STEP1: "Drawer/GET_STEP1_COMPLETE",
      GET_STEP2: "Drawer/GET_STEP2_COMPLETE",
      GET_STEP3: "Drawer/GET_STEP3_COMPLETE",
      GET_STEP4: "Drawer/GET_STEP4_COMPLETE"
    }),
  },
  data: () => ({
    e1: 1,
    editable: true,
    isComplete1: false,
    isComplete2: false,
    isComplete3: false,
  }),
  created() {
    this.e1 = this.$store.getters['Drawer/GET_STEP']
    this.isComplete1 = this.GET_STEP1
    this.isComplete2 = this.GET_STEP2
    this.isComplete3 = this.GET_STEP3
    this.isComplete4 = this.GET_STEP4
  },
  methods: {
    ...mapMutations({
      LOADER: "Drawer/SET_LOADER",
      Q_MERGE: "Quotation/MERGE_ALL_ELEMENT",
      Q_PRODUCT: "Quotation/SET_PRODUCT_LIST",
      C_MERGE: "Contract/MERGE_ALL_ELEMENT"
    }),
    async se_step() {
      if (this.e1 == 1) { //หน้าเสนอราคา
        // console.log(this.CU_GET_ALL.NEWCUSTOMER_ID)
        this.LOADER(true)
        let result = await this.$token_api.post('/step-quotation-by-customer-id', { CUSTOMER_ID: this.CU_GET_ALL.NEWCUSTOMER_ID }).catch((err) => { this.LOADER(false) })

        if (result.data.data.length > 0) {
          let q_detail = result.data.data
          const prod_detail = await new Response(q_detail[0].PRODUCT_LIST).json()
          this.Q_MERGE(q_detail[0])
          this.Q_PRODUCT(prod_detail)
          console.log(this.Q_GET)

          this.LOADER(false)

        } else {
          this.LOADER(false)
        }



      } else if (this.e1 == 2) { //หน้าสัญญา

      } else {

      }

    },

  },
  beforeRouteEnter(to, from, next) {

    next(vm => {
      vm.$refs.quotaion_from.getPreviousRoute(from)
      vm.$refs.contract_from.getPreviousRoute(from)
      vm.$refs.bill_form.getPreviousRoute(from)
      vm.$refs.invoice_form.getPreviousRoute(from)
      // vm.pre_route = from
      // access to component's instance using `vm` . this is done because this navigation guard is called before the component is created.


    })
  },


};
</script>
